import React, { Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { systemUser, SystemUser } from "../config/constants/system-users";
import appRoutePath from "../config/path";

interface RoleBaseRouteGuardProps {
  children: React.ReactNode;
  roles: SystemUser[];
}

export const RoleBaseRouteGuard: React.FC<RoleBaseRouteGuardProps> = ({
  children,
  roles,
}) => {
  const currentUser = useAppSelector((state) => state.authVerify);
  const navigate = useNavigate();

  useEffect(() => {
    const allowRoles: SystemUser[] = [...roles, systemUser.SUPER_ADMIN,systemUser.DIRECTOR];

    if (!currentUser.role) {
      return;
    }

    if (!allowRoles.includes(currentUser.role)) {
      navigate(appRoutePath.UnAUTHORIZED_ACCESS_PAGE, { replace: true });
    }
  }, [currentUser.role, roles, navigate]);

  if (!currentUser.role) {
    return null
  }

  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
};
